import React, { useState, useEffect } from 'react';
import { Box, Typography, Tabs, Tab, IconButton, TextField, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Modal, Button, Select, MenuItem, InputLabel, FormControl, Pagination, Snackbar, Alert } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete'; // Ícone para ver clichês eliminados
import DashboardLayout from './DashboardLayout';
import EditIcon from '@mui/icons-material/Edit';
import axios from 'axios';
import Cliches360imprimir from './Cliches360imprimir'; // Importa o novo componente



const TIPO_CLICHE_CHOICES = [
    { value: 'CLICHÊS_PARA_MONTAR', label: 'Clichês para Montar' },
    { value: 'CLICHÊS_INTEIROS', label: 'Clichês Inteiros' },
];
function removeAccents(str) {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}


const TIPO_CLICHE_CHOICES2 = [
    { value: 'CLICHES_PARA_MONTAR', label: 'Clichês para Montar' },
    { value: 'CLICHES_INTEIROS', label: 'Clichês Inteiros' },
];

const TAMANHO_CHOICES = [
    '54*16*43', '54*16*49', '42*16*34', '42*16*44', '42*16*49', '40*11*32', '40*11*37',
    '35*16*44', '31*20*32', '30*16*31', '32*11*28', '32*11*42',
    '27*16*31', '28*11*32', '28*11*37', '28*11*22', '24*11*32', '22*10*27', '18*8*24', '18*8*39'
];

const ClichesMoldes = () => {
    const [alert, setAlert] = useState({ open: false, message: '', severity: 'success' });
    const [searchTerm, setSearchTerm] = useState('');
    const [tabValue, setTabValue] = useState(0); // Estado para alternar entre as abas
    const [cliches, setCliches] = useState([]);  // Estado para armazenar os clichês da API
    const [selectedCliche, setSelectedCliche] = useState(null);
    const [newClicheModalOpen, setNewClicheModalOpen] = useState(false);
    const user = JSON.parse(localStorage.getItem('user'));
    const [nomeTrabalhoFilter, setNomeTrabalhoFilter] = useState('');
    const [numeroClicheFilter, setNumeroClicheFilter] = useState('');
    const [tipoClicheFilter, setTipoClicheFilter] = useState('');
    const [tamanhoFilter, setTamanhoFilter] = useState('');
    const [bobineFilter, setBobineFilter] = useState('');
    const [dataCriacaoFilter, setDataCriacaoFilter] = useState('');
    const [advancedSearchOpen, setAdvancedSearchOpen] = useState(false);
    const [advancedSearch, setAdvancedSearch] = useState({
        tipo_cliche: '',
        bobine: '',
    });
    const [editingClicheId, setEditingClicheId] = useState(null);
    const [editedNomeTrabalho, setEditedNomeTrabalho] = useState('');
    const [searchResults, setSearchResults] = useState([]); // Para os resultados da pesquisa
    const [resultsModalOpen, setResultsModalOpen] = useState(false); // Para exibir a modal de resultados
    // Estados para paginação
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 50;  // Limite de 50 entradas por página

    const [newCliche, setNewCliche] = useState({
        nome_trabalho: '',
        tipo_cliche: '',
        tamanho: '',
        foto: null,
        hora: '' // Adicionar a hora
    });
    const [updatePhotoModalOpen, setUpdatePhotoModalOpen] = useState(false);
    const [selectedClicheForPhotoUpdate, setSelectedClicheForPhotoUpdate] = useState(null);
    
    const [stream, setStream] = useState(null);
    const [videoElement, setVideoElement] = useState(null);
    const [imageSrc, setImageSrc] = useState(null); // Armazenar a imagem capturada

    // Verifica se o utilizador pertence à secção 'Admin'
    const isAdmin = user && user.seccao === 'Admin';

    const apiBaseURL = 'https://plasticemployers.duckdns.org';  


    const fetchAdvancedSearch = async (filters) => {
        try {
            const response = await axios.get(`${apiBaseURL}/api/advanced-search/`, {
                params: filters,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao buscar resultados da pesquisa avançada:', error);
            return [];
        }
    };
    const fetchData = async () => {
        try {
          const data = await fetchCliches();
          setCliches(data);
        } catch (error) {
          console.error("Erro ao buscar clichês:", error);
        }
      };


    // Abrir a modal para atualizar a foto
    const handleOpenUpdatePhotoModal = (cliche) => {
        setSelectedClicheForPhotoUpdate(cliche);
        setUpdatePhotoModalOpen(true);
    };

    // Fechar a modal de atualização de foto
    const handleCloseUpdatePhotoModal = () => {
        setSelectedClicheForPhotoUpdate(null);
        setUpdatePhotoModalOpen(false);
    };

    // Função para atualizar a foto do clichê
    const handleUpdatePhoto = async () => {
        console.log("click");
        console.log("selectedClicheForPhotoUpdate:", selectedClicheForPhotoUpdate);
    console.log("imageSrc:", imageSrc);


        try {
            const formData = new FormData();
            const response = await fetch(imageSrc);
            const blob = await response.blob();
            formData.append('foto', blob, 'captured-image.png');

            const token = localStorage.getItem('access');
            const res = await axios.patch(
                `${apiBaseURL}/api/clichechangeimage/${selectedClicheForPhotoUpdate.id}/`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            setAlert({
                open: true,
                message: 'Foto atualizada com sucesso!',
                severity: 'success',
            });

            // Atualizar a lista de clichês
            const data = await fetchCliches();
            setCliches(data);

            // Fechar a modal
            handleCloseUpdatePhotoModal();
        } catch (error) {
            setAlert({
                open: true,
                message: 'Erro ao atualizar a foto.',
                severity: 'error',
            });
            console.error('Erro ao atualizar a foto:', error);
        }
    };

    const handleViewDeletedCliches = () => {
        // Lógica para ver clichês eliminados
    };

    // Função para alternar entre as abas
    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    const openCamera = async () => {
        try {
            // Solicita permissão do utilizador para acessar a câmera
            const mediaStream = await navigator.mediaDevices.getUserMedia({ video: true });

            // Se a permissão for concedida, continua a configurar o vídeo
            setStream(mediaStream);

            const videoElement = document.createElement('video');
            videoElement.srcObject = mediaStream;
            videoElement.play();
            setVideoElement(videoElement);

            // Exibir o vídeo na interface
            const videoContainer = document.getElementById('video-container');
            videoContainer.appendChild(videoElement);
        } catch (err) {
            if (err.name === 'NotAllowedError') {
                setAlert({ open: true, message: 'Permissão para acessar a câmera negada.', severity: 'error' });
            } else if (err.name === 'NotFoundError') {
                setAlert({ open: true, message: 'Nenhuma câmera disponível.', severity: 'error' });
            } else {
                setAlert({ open: true, message: 'Erro ao acessar a câmera.', severity: 'error' });
            }
        }
    };

    const takePicture = () => {
        if (videoElement) {
            // Criar um canvas temporário para capturar a imagem do vídeo
            const canvas = document.createElement('canvas');
            canvas.width = videoElement.videoWidth;
            canvas.height = videoElement.videoHeight;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(videoElement, 0, 0, canvas.width, canvas.height);

            // Obter a imagem em formato base64
            const imageDataUrl = canvas.toDataURL('image/png');
            setImageSrc(imageDataUrl); // Armazenar a imagem capturada

            // Parar o stream de vídeo após capturar a imagem
            closeCamera();
        }
    };

    const closeCamera = () => {
        if (stream) {
            const tracks = stream.getTracks();
            tracks.forEach(track => track.stop());
            setStream(null);
            if (videoElement) {
                videoElement.remove();
            }
        }
    };

    const refreshAccessToken = async () => {
        try {
            const refreshToken = localStorage.getItem('refresh');
            const response = await axios.post(`${apiBaseURL}/api/token/refresh/`, {
                refresh: refreshToken,
            });
            localStorage.setItem('access', response.data.access);
            return response.data.access;
        } catch (error) {
            console.error('Erro ao atualizar o token de acesso:', error);
            // Redirecionar para login se o token não puder ser atualizado
            return null;
        }
    };

    useEffect(() => {
        // Chamar a API para buscar os clichês e atualizar o estado
        const fetchData = async () => {
            const data = await fetchCliches();
            setCliches(data);  // Atualiza o estado de 'cliches' com os dados retornados
        };
        fetchData();
    }, []);

    const fetchCliches = async () => {
        try {
            const response = await axios.get(`${apiBaseURL}/api/cliches/`);
            return response.data;  // Retorna os dados recebidos da API
        } catch (error) {
            console.error('Erro ao buscar clichês:', error);
            return [];
        }
    };

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };

    const handleOpenModal = (cliche) => {
        // Garante que a foto tenha o caminho completo
        const processedCliche = {
            ...cliche,
            foto: cliche.foto ? (cliche.foto.startsWith('http') ? cliche.foto : `${apiBaseURL}${cliche.foto}`) : null,
        };
    
        setSelectedCliche(processedCliche);
    };

    const handleCloseModal = () => {
        setSelectedCliche(null);
    };

    const handleOpenNewClicheModal = () => {
        setNewClicheModalOpen(true);
    };

    const handleCloseNewClicheModal = () => {
        setNewClicheModalOpen(false);
    };

    const handleCreateCliche = async () => {
        try {
            const { tipo_cliche, tamanho, nome_trabalho, foto } = newCliche;
    
            if (!tipo_cliche || !tamanho) {
                console.error('Tipo de clichê ou tamanho não definidos');
                return;
            }
    
            // Calcular a bobine com base no tamanho
            const [largura, fole, altura] = tamanho.split('*').map(Number);
            const bobine = largura * 2 + fole * 2 + 3;
    
            // Normalizar o tipo de clichê
            const tipoClicheNormalized = removeAccents(tipo_cliche);
    
            // Obter o token do utilizador
            const token = localStorage.getItem('access');
    
            if (!token) {
                console.error('Utilizador não autenticado');
                setAlert({ open: true, message: 'Utilizador não autenticado.', severity: 'error' });
                return;
            }
    
            let lastClicheResponse = null;
            let numero_cliche = null;
    
            // Obter o último número de clichê dependendo do tipo
            
            lastClicheResponse = await axios.get(
                `${apiBaseURL}/api/cliches/last-number/${tipoClicheNormalized}/${bobine}/`,
                {
                    headers: {
                            Authorization: `Bearer ${token}`,
                    },
                }
            );
            
            

            // Incrementar o último número de clichê
            const lastClicheNumber = parseInt(lastClicheResponse.data.last_number, 10) || 0;
            numero_cliche = lastClicheNumber + 1;
    
            // Definir o tipo de clichê final
            let tipo_cliche_final = tipo_cliche;
            if (tipoClicheNormalized === "CLICHES_INTEIROS") {
                tipo_cliche_final = "CLICHES_INTEIROS";
            } else if (tipoClicheNormalized === "CLICHES_PARA_MONTAR") {
                tipo_cliche_final = "CLICHES_PARA_MONTAR";
            }
    
            const formData = new FormData();
            formData.append('nome_trabalho', nome_trabalho);
            formData.append('tipo_cliche', tipo_cliche_final);
            formData.append('tamanho', tamanho);
            formData.append('bobine', bobine); // Adicionar bobine para qualquer tipo de clichê
            formData.append('numero_cliche', numero_cliche.toString());
    
            // Adiciona a bobine apenas se for "CLICHÊS INTEIROS"
            if (tipoClicheNormalized === "CLICHES_INTEIROS") {
                formData.append('bobine', bobine);
            }
    
            formData.append('criado_por', user.id);
    
            // Obter data e hora atuais
            const currentDate = new Date();
            const formattedDate = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1)
                .toString()
                .padStart(2, '0')}-${currentDate
                .getDate()
                .toString()
                .padStart(2, '0')} ${currentDate
                .getHours()
                .toString()
                .padStart(2, '0')}:${currentDate
                .getMinutes()
                .toString()
                .padStart(2, '0')}:${currentDate
                .getSeconds()
                .toString()
                .padStart(2, '0')}`;
    
            formData.append('data_criacao', formattedDate);
    
            // Adicionar a imagem capturada pela câmara ou carregada através do botão de upload
            if (imageSrc) {
                // Se a imagem foi capturada pela câmara
                const response = await fetch(imageSrc);
                const blob = await response.blob();
                formData.append('foto', blob, 'captured-image.png');
            } else if (newCliche.foto) {
                // Se a imagem foi carregada através do botão de upload
                formData.append('foto', foto);
            }
    
            // Fazer o POST para criar o clichê
            const response = await axios.post(`${apiBaseURL}/api/cliches/`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${token}`,
                },
            });
    
            console.log('Clichê criado com sucesso:', response.data);
            setAlert({
                open: true,
                message: `Clichê Criado, por favor, guarde no local do ${tipo_cliche_final} com a bobine ${bobine} e com o numero ${numero_cliche} . Obrigado pela colaboração.`,
                severity: 'success',
            });
    
            // Atualizar a lista de clichês
            const data = await fetchCliches();
            setCliches(data);
    
            // Fechar o modal
            handleCloseNewClicheModal();
    
        } catch (error) {
            setAlert({ open: true, message: 'Erro ao criar clichê.', severity: 'error' });
            if (error.response) {
                console.log('Erro na resposta:', error.response.data);
            } else {
                console.log('Erro geral:', error.message);
            }
            console.error('Erro ao criar clichê:', error);
        }
    };    
    
    
    
    

    const filteredCliches = cliches.filter(cliche =>
        cliche.nome_trabalho.toLowerCase().includes(nomeTrabalhoFilter.toLowerCase()) &&
        cliche.numero_cliche.toLowerCase().includes(numeroClicheFilter.toLowerCase()) &&
        cliche.tipo_cliche.toLowerCase().includes(tipoClicheFilter.toLowerCase()) &&
        cliche.tamanho.toLowerCase().includes(tamanhoFilter.toLowerCase()) &&
        (cliche.bobine ? cliche.bobine.toLowerCase().includes(bobineFilter.toLowerCase()) : true) &&
        cliche.data_criacao.toLowerCase().includes(dataCriacaoFilter.toLowerCase())
    );

    // Calcular os itens para a página atual
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredCliches.slice(indexOfFirstItem, indexOfLastItem);

    const handlePageChange = (event, value) => {
        setCurrentPage(value);
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (!file) return;
    
        // Caso de criação de novo clichê
        if (newCliche) {
            setNewCliche({ ...newCliche, foto: file });
        }
    
        // Caso de alteração de foto existente
        if (selectedClicheForPhotoUpdate) {
            const imageUrl = URL.createObjectURL(file); // Gera um preview para a imagem
            setImageSrc(imageUrl); // Atualiza o preview
        }
    };

    return (
        <DashboardLayout>
            <Box sx={{ mt: 4 }}>
            <Typography variant="h4" gutterBottom>Gestão de Clichês</Typography>
{/* Tabs para alternar entre as diferentes visualizações */}
<Tabs value={tabValue} onChange={handleTabChange}>
                    <Tab label="Clichês Plásticos Dão" />
                    <Tab label="Clichês 360imprimir" />
                </Tabs>

                {tabValue === 0 && (
                    <Box sx={{ mt: 4 }}>
                        <Typography variant="h5" gutterBottom>Clichês Plásticos Dão</Typography>
                        {/* Coloca aqui o conteúdo da aba "Clichês Plásticos Dão" */}
                        {/* Copiar o conteúdo que já tens para exibir os clichês normais */}
                <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ mb: 3 }}>
            {/* Botão para ver clichês eliminados, visível apenas para Admin */}
            {isAdmin && (
                <Button 
                    variant="contained" 
                    color="secondary" 
                    onClick={handleViewDeletedCliches}
                    startIcon={<DeleteIcon />}
                >
                    Ver Clichês Eliminados
                </Button>
            )}
            <IconButton color="primary" onClick={() => setAdvancedSearchOpen(true)}>
                Pesquisa Avançada
            </IconButton>


            {/* Botão para criar novo clichê */}
            <IconButton color="primary" onClick={handleOpenNewClicheModal}>
               Adicionar Clichê  <AddIcon />
            </IconButton>
        </Box>

                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>
                                    <TextField
                                        placeholder="Nome do Trabalho"
                                        variant="outlined"
                                        size="small"
                                        value={nomeTrabalhoFilter}
                                        onChange={(e) => setNomeTrabalhoFilter(e.target.value)}
                                    />
                                </TableCell>
                                <TableCell>
                                    <TextField
                                        placeholder="Número do Clichê"
                                        variant="outlined"
                                        size="small"
                                        value={numeroClicheFilter}
                                        onChange={(e) => setNumeroClicheFilter(e.target.value)}
                                    />
                                </TableCell>
                                <TableCell>
                                    <TextField
                                        placeholder="Tipo do Clichê"
                                        variant="outlined"
                                        size="small"
                                        value={tipoClicheFilter}
                                        onChange={(e) => setTipoClicheFilter(e.target.value)}
                                    />
                                </TableCell>
                                <TableCell>
                                    <TextField
                                        placeholder="Tamanho"
                                        variant="outlined"
                                        size="small"
                                        value={tamanhoFilter}
                                        onChange={(e) => setTamanhoFilter(e.target.value)}
                                    />
                                </TableCell>
                                <TableCell>
                                    <TextField
                                        placeholder="Bobine"
                                        variant="outlined"
                                        size="small"
                                        value={bobineFilter}
                                        onChange={(e) => setBobineFilter(e.target.value)}
                                    />
                                </TableCell>
                                <TableCell>
                                    <TextField
                                        placeholder="Data de Criação"
                                        variant="outlined"
                                        size="small"
                                        value={dataCriacaoFilter}
                                        onChange={(e) => setDataCriacaoFilter(e.target.value)}
                                    />
                                    
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {currentItems.map((cliche) => (
                                <TableRow 
                                key={cliche.id} 
                                onClick={() => handleOpenModal(cliche)}
                                sx={{
                                    cursor: 'pointer',
                                    transition: 'box-shadow 0.3s ease-in-out', // Suaviza a transição
                                    '&:hover': {
                                        backgroundColor: '#9ac6f5',
                                        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.2)', // Adiciona a borda em "hover"
                                    },
                                }}
                            >
                                    <TableCell>
                                    {editingClicheId === cliche.id ? (
                                        <Box display="flex" alignItems="center">
                                        <TextField
                                            value={editedNomeTrabalho}
                                            onChange={(e) => setEditedNomeTrabalho(e.target.value)}
                                            size="small"
                                            onMouseDown={(e) => e.stopPropagation()}
                                            onClick={(e) => e.stopPropagation()}
                                        />
                                        <IconButton
                                        onMouseDown={(e) => e.stopPropagation()}
                                        onClick={async (e) => {
                                            e.stopPropagation();
                                            try {
                                            const token = localStorage.getItem('access');
                                            await axios.patch(
                                                `${apiBaseURL}/api/cliches/${cliche.id}/update_name/`,
                                                { nome_trabalho: editedNomeTrabalho },
                                                { headers: { Authorization: `Bearer ${token}` } }
                                            );
                                            setAlert({
                                                open: true,
                                                message: "Nome actualizado com sucesso",
                                                severity: "success"
                                            });
                                            await fetchData();
                                            setEditingClicheId(null);
                                            } catch (error) {
                                            console.error("Erro ao atualizar o nome:", error);
                                            }
                                        }}
                                        >
                                        <span role="img" aria-label="confirmar">✅</span>
                                        </IconButton>

                                        <IconButton
                                            onMouseDown={(e) => e.stopPropagation()}
                                            onClick={(e) => {
                                            e.stopPropagation();
                                            setEditingClicheId(null);
                                            }}
                                        >
                                            <span role="img" aria-label="cancelar">❌</span>
                                        </IconButton>
                                        </Box>
                                    ) : (
                                        <Box display="flex" alignItems="center">
                                        <Typography variant="body1">{cliche.nome_trabalho}</Typography>
                                        {isAdmin && (
                                            <IconButton
                                            onMouseDown={(e) => e.stopPropagation()}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setEditingClicheId(cliche.id);
                                                setEditedNomeTrabalho(cliche.nome_trabalho);
                                            }}
                                            >
                                            <EditIcon fontSize="small" />
                                            </IconButton>
                                        )}
                                        <IconButton
                                            color="primary"
                                            onClick={(e) => {
                                                e.stopPropagation(); // Impede que o clique na IconButton abra a modal
                                                handleOpenUpdatePhotoModal(cliche);
                                            }}
                                        >
                                            <AddIcon /> {/* Ícone de lápis */}
                                        </IconButton>
                                        </Box>
                                    )}
                                    
                                    </TableCell>
                                    <TableCell>{cliche.numero_cliche}</TableCell>
                                    <TableCell>{cliche.tipo_cliche}</TableCell>
                                    <TableCell>{cliche.tamanho}</TableCell>
                                    <TableCell>{cliche.bobine || 'N/A'}</TableCell>
                                    <TableCell>{cliche.data_criacao}</TableCell>
                                    <TableCell>
                                        
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>

                {/* Paginação */}
                <Pagination
                    count={Math.ceil(filteredCliches.length / itemsPerPage)}
                    page={currentPage}
                    onChange={handlePageChange}
                    sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}
            />

<Modal open={updatePhotoModalOpen} onClose={handleCloseUpdatePhotoModal}>
    <Box 
        sx={{ 
            p: 4, 
            backgroundColor: 'white', 
            width: '90%', 
            maxWidth: 500, 
            margin: 'auto', 
            mt: { xs: '20%', sm: '10%' }, 
            borderRadius: 2, 
            maxHeight: '80vh',
            overflowY: 'auto' 
        }}
    >
        <Typography variant="h5" gutterBottom>Atualizar Foto do Clichê</Typography>
        
        <Box>
            <Button variant="contained" onClick={openCamera} fullWidth sx={{ mt: 2 }}>
                Abrir Câmera
            </Button>
            <Box id="video-container" sx={{ mt: 2 }} />
            {imageSrc && <img src={imageSrc} alt="Captured" style={{ width: '100%' }} />}
            {stream && (
                <Button variant="contained" color="primary" onClick={takePicture} fullWidth sx={{ mt: 2 }}>
                    Tirar Foto
                </Button>
            )}
            {stream && (
                <Button variant="contained" color="secondary" onClick={closeCamera} fullWidth sx={{ mt: 2 }}>
                    Fechar Câmera
                </Button>
            )}
        </Box>
        
        <Button variant="contained" component="label" fullWidth sx={{ mt: 2 }}>
            Adicionar Foto
            <input type="file" hidden onChange={handleFileChange} />
        </Button>
        
        <Box mt={2} display="flex" justifyContent="space-between">
            <Button variant="contained" color="primary" onClick={handleUpdatePhoto}>Confirmar</Button>
            <Button variant="outlined" color="secondary" onClick={handleCloseUpdatePhotoModal}>Cancelar</Button>
        </Box>
    </Box>
</Modal>

                {/* Modal para exibir detalhes do clichê */}
{selectedCliche && (
    <Modal open={Boolean(selectedCliche)} onClose={handleCloseModal}>
        <Box 
            sx={{ 
                p: 4, 
                backgroundColor: 'white', 
                width: '90%', 
                maxWidth: 500, 
                margin: 'auto', 
                mt: { xs: '20%', sm: '10%' }, 
                borderRadius: 3, // Borda arredondada mais suave
                boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)', // Sombra suave
                textAlign: 'center', // Centraliza o conteúdo
                maxHeight: '80vh', // Limite de altura da modal (80% da altura da viewport)
                overflowY: 'auto' // Adiciona rolagem quando o conteúdo excede a altura
            }}
        
        >
            <Typography variant="h4" gutterBottom color="primary" sx={{ fontWeight: 'bold' }}>
                {selectedCliche.nome_trabalho}
            </Typography>
            
            <Box sx={{ my: 2 }}>
                <Typography variant="body1" sx={{ fontWeight: 'bold' }}>Número do Clichê</Typography>
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>{selectedCliche.numero_cliche}</Typography>
            </Box>

            <Box sx={{ my: 2 }}>
                <Typography variant="body1" sx={{ fontWeight: 'bold' }}>Tipo do Clichê</Typography>
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>{selectedCliche.tipo_cliche}</Typography>
            </Box>

            <Box sx={{ my: 2 }}>
                <Typography variant="body1" sx={{ fontWeight: 'bold' }}>Tamanho</Typography>
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>{selectedCliche.tamanho}</Typography>
            </Box>

            <Box sx={{ my: 2 }}>
                <Typography variant="body1" sx={{ fontWeight: 'bold' }}>Bobine</Typography>
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>{selectedCliche.bobine}</Typography>
            </Box>

            {selectedCliche.foto ? (
                <Box sx={{ my: 2, borderRadius: 2, overflow: 'hidden' }}>
                    <img src={selectedCliche.foto} alt={selectedCliche.nome_trabalho} style={{ width: '100%', borderRadius: '8px' }} />
                </Box>
            ) : (
                <Typography sx={{ my: 2, color: 'text.secondary', fontStyle: 'italic' }}>
                    Pré-visualização não disponível
                </Typography>
            )}

            <Button 
                onClick={handleCloseModal} 
                variant="contained" 
                color="primary" 
                sx={{ mt: 2, px: 4 }}
            >
                Fechar
            </Button>
        </Box>
    </Modal>
)}


                {/* Modal para adicionar novo clichê */}
                <Modal open={newClicheModalOpen} onClose={handleCloseNewClicheModal}>
    <Box 
        sx={{ 
            p: 4, 
            backgroundColor: 'white', 
            width: '90%', // A modal ocupará 90% da largura da tela
            maxWidth: 500, // Máximo de 500px
            margin: 'auto', 
            mt: { xs: '20%', sm: '10%' }, // Margem superior de 20% em telas pequenas e 10% em maiores
            borderRadius: 2, // Bordas arredondadas para um visual mais moderno
            maxHeight: '80vh', // Limite de altura da modal (80% da altura da viewport)
            overflowY: 'auto' // Adiciona rolagem quando o conteúdo excede a altura
        }}
    >
        <Typography variant="h5" gutterBottom>Adicionar Novo Clichê</Typography>
        
        <TextField
            label="Nome do Trabalho"
            fullWidth
            margin="normal"
            value={newCliche.nome_trabalho}
            onChange={(e) => setNewCliche({ ...newCliche, nome_trabalho: e.target.value })}
        />
        
        <FormControl fullWidth margin="normal">
            <InputLabel>Tipo do Clichê</InputLabel>
            <Select
                value={newCliche.tipo_cliche}
                onChange={(e) => setNewCliche({ ...newCliche, tipo_cliche: e.target.value })}
            >
                {TIPO_CLICHE_CHOICES2.map(choice => (
                    <MenuItem key={choice.value} value={choice.value}>{choice.label}</MenuItem>
                ))}
            </Select>
        </FormControl>
        
        <FormControl fullWidth margin="normal">
            <InputLabel>Tamanho</InputLabel>
            <Select
                value={newCliche.tamanho}
                onChange={(e) => setNewCliche({ ...newCliche, tamanho: e.target.value })}
            >
                {TAMANHO_CHOICES.map(choice => (
                    <MenuItem key={choice} value={choice}>{choice}</MenuItem>
                ))}
            </Select>
        </FormControl>

        <Box>
            <Button variant="contained" onClick={openCamera} fullWidth sx={{ mt: 2 }}>
                Abrir Câmera
            </Button>

            {/* Container para o vídeo da câmera */}
            <Box id="video-container" sx={{ mt: 2 }} />

            {/* Exibir imagem capturada */}
            {imageSrc && <img src={imageSrc} alt="Captured" style={{ width: '100%' }} />}

            {/* Botão para capturar a imagem */}
            {stream && (
                <Button variant="contained" color="primary" onClick={takePicture} fullWidth sx={{ mt: 2 }}>
                    Tirar Foto
                </Button>
            )}

            {/* Botão para fechar a câmera */}
            {stream && (
                <Button variant="contained" color="secondary" onClick={closeCamera} fullWidth sx={{ mt: 2 }}>
                    Fechar Câmera
                </Button>
            )}
        </Box>
        
        
        <Button variant="contained" component="label" fullWidth sx={{ mt: 2 }}>
Adicionar Foto
<input type="file" accept="image/png, image/jpeg" hidden onChange={handleFileChange} />
</Button>

        
        <Box mt={2} display="flex" justifyContent="space-between">
            <Button variant="contained" color="primary" onClick={handleCreateCliche}>Confirmar</Button>
            <Button variant="outlined" color="secondary" onClick={handleCloseNewClicheModal}>Cancelar</Button>
        </Box>
    </Box>
</Modal>
<Modal open={advancedSearchOpen} onClose={() => setAdvancedSearchOpen(false)}>
    <Box 
        sx={{ 
            p: 4, 
            backgroundColor: 'white', 
            width: '90%', 
            maxWidth: 400, 
            margin: 'auto', 
            mt: { xs: '20%', sm: '10%' }, 
            borderRadius: 2, 
            maxHeight: '80vh', 
            overflowY: 'auto' 
        }}
    >
        <Typography variant="h5" gutterBottom>Pesquisa Avançada</Typography>
        
        <FormControl fullWidth margin="normal">
            <InputLabel>Tipo do Clichê</InputLabel>
            <Select
                value={advancedSearch.tipo_cliche}
                onChange={(e) => setAdvancedSearch({ ...advancedSearch, tipo_cliche: e.target.value })}
            >
                {TIPO_CLICHE_CHOICES2.map(choice => (
                    <MenuItem key={choice.value} value={choice.value}>{choice.label}</MenuItem>
                ))}
            </Select>
        </FormControl>
        
        <TextField
            label="Bobine"
            fullWidth
            margin="normal"
            value={advancedSearch.bobine}
            onChange={(e) => setAdvancedSearch({ ...advancedSearch, bobine: e.target.value })}
        />
        
        <Box mt={2} display="flex" justifyContent="space-between">
            <Button 
                variant="contained" 
                color="primary" 
                onClick={async () => {
                    const results = await fetchAdvancedSearch(advancedSearch);
                    setSearchResults(results);
                    setAdvancedSearchOpen(false);
                    setResultsModalOpen(true);
                }}
            >
                Procurar
            </Button>
            <Button 
                variant="outlined" 
                color="secondary" 
                onClick={() => setAdvancedSearchOpen(false)}
            >
                Cancelar
            </Button>
        </Box>
    </Box>
</Modal>

<Modal open={resultsModalOpen} onClose={() => setResultsModalOpen(false)}>
    <Box 
        sx={{ 
            p: 6, 
            backgroundColor: 'white', 
            width: '90%', 
            maxWidth: 600, 
            margin: 'auto', 
            mt: { xs: '10%', sm: '5%' }, 
            borderRadius: 2, 
            maxHeight: '80vh', 
            overflowY: 'auto' 
        }}
    >
        <Typography variant="h5" gutterBottom>Resultados da Pesquisa</Typography>
        
        {searchResults.length > 0 ? (
            searchResults.map((result) => (
                <Box
                    key={result.id}
                    onClick={() => handleOpenModal(result)} // Usa a lógica centralizada
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        mb: 2,
                        p: 2,
                        border: '1px solid #ccc',
                        borderRadius: 2,
                        cursor: 'pointer',
                        transition: 'all 0.3s ease', // Transição suave
                        '&:hover': {
                            backgroundColor: '#007BFF',
                            transform: 'scale(1.05)',
                            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
                        },
                    }}
                >
                    {result.foto ? (
                        <img
                            src={result.foto.startsWith('http') ? result.foto : `${apiBaseURL}${result.foto}`} // Adiciona o baseURL apenas se necessário
                            alt={result.nome_trabalho}
                            style={{
                                width: 100,
                                height: 100,
                                objectFit: 'cover',
                                marginRight: 16,
                                borderRadius: 4,
                            }}
                        />
                    ) : (
                        <Box
                            sx={{
                                width: 50,
                                height: 50,
                                backgroundColor: '#f0f0f0',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                marginRight: 16,
                                borderRadius: 4,
                            }}
                        >
                            <Typography variant="caption" color="text.secondary">
                                Sem Foto
                            </Typography>
                        </Box>
                    )}
                    <Typography variant="body1">{result.nome_trabalho}</Typography>
                </Box>
            ))
        ) : (
            <Typography color="text.secondary">Nenhum resultado encontrado.</Typography>
        )}

        
        <Button 
            onClick={() => setResultsModalOpen(false)} 
            variant="contained" 
            color="primary" 
            fullWidth 
            sx={{ mt: 2 }}
        >
            Fechar
        </Button>
    </Box>
</Modal>

</Box>
                )}

{tabValue === 1 && (
    <Cliches360imprimir />
)}

{/* Snackbar para exibir os alertas */}
<Snackbar
                open={alert.open}
                autoHideDuration={6000}
                onClose={() => setAlert({ ...alert, open: false })}
            >
                <Alert onClose={() => setAlert({ ...alert, open: false })} severity={alert.severity}>
                    {alert.message}
                </Alert>
            </Snackbar>
            </Box>
    
        </DashboardLayout>
    );
};

export default ClichesMoldes;